// import logo from './logo.svg';
import './App.css';
import Title from "./Title";

interface AppProps {
  isProduction: boolean;
}

export default function App(props:AppProps) {
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <Title />
      </header>
    </div>
  );
}
